<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="createDialog"
              >新增分班</el-button
            >
            <el-button
              v-access:add
              icon="el-icon-s-data"
              size="small"
              @click="autoCreate"
              >自动分班</el-button
            >
          </div>
        </el-row>
      </div>

      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="救护培训分班" name="lifeGuard">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="classModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="ClassName"
                label="班级名称"
                sortable
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="ClassType"
                label="班级类型"
                sortable
                :formatter="ClassType"
              ></el-table-column>
              <el-table-column
                prop="StuNum"
                label="班级人数"
                sortable
                align="right"
              ></el-table-column>
              <el-table-column
                prop="IsReachSize"
                label="是否达到开班人数"
                sortable
                :formatter="IsReachSize"
              ></el-table-column>
              <el-table-column
                prop="IsClassed"
                label="是否已开班"
                sortable
                :formatter="IsClassed"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="showInfo(scope.row)"
                    type="text"
                    size="mini"
                    >人员列表</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="openClass(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.IsClassed !== true"
                    >确认开班</el-button
                  >
                  <el-button
                    v-access:modify
                    @click="innerTransfer(scope.row)"
                    type="text"
                    size="mini"
                    v-if="scope.row.IsClassed !== true"
                    >调班</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <!--新增分班dialog-->
    <el-dialog
      title="新增分班"
      :visible.sync="classDialog"
      width="80%"
      :before-close="handleClose"
      append-to-body
      @selection-change="onSelectionChange"
      :close-on-click-modal="false"
      class="fistdig"
    >
      <div class="el-dialog-div">
        <el-form
          ref="dataForm1"
          :model="dateForm1"
          :disabled="isdisableds1"
          :rules="materialsRules"
        >
          <el-table
            border
            hightlight-current-row
            style="width: 100%"
            :header-cell-class-name="headerRow"
            :data="noClassPeople"
            ref="multipleTable"
            @selection-change="onSelectionChange"
            :max-height="tableMaxHeight()"
            v-loading="isloading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="Name"
              label="报名人员"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              label="联系电话"
              sortable
            ></el-table-column>
            <el-table-column
              prop="MemberType"
              label="报名人员类型"
              sortable
              align="right"
              :formatter="MemberType"
            ></el-table-column>
            <el-table-column
              prop="SignUpNum"
              label="报名人数"
              sortable
            ></el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="classDialog = false">取 消</el-button>
        <el-button type="primary" @click="addmaterialsdialog()"
          >提 交</el-button
        >
      </span>
      <div class="pagination-wapper">
        <OfPagination
          :total="totalTwo"
          :pageSize="pageSizeTwo"
          :currentPage="currentPageTwo"
          @onSizeChange="handleSizeChangeTwo"
          @onCurrentChange="handleCurrentChangeTwo"
        ></OfPagination>
      </div>
    </el-dialog>
    <!--详情dialog-->
    <el-dialog
      title="班级人员列表"
      :visible.sync="infoDialog"
      width="80%"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
      class="fistdig"
    >
      <el-button
        v-access:add
        icon="el-icon-plus"
        size="small"
        @click="showInserDialog"
        :disabled="isloading"
        type="primary"
        style="margin-bottom: 10px"
        >新增人员</el-button
      >
      <div class="el-dialog-div">
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="classPeople"
          ref="multipleTable"
          @selection-change="onSelectionChange"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Name"
            label="报名人员"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Phone"
            label="联系电话"
            sortable
          ></el-table-column>
          <el-table-column
            prop="MemberType"
            label="报名人员类型"
            sortable
            align="right"
            :formatter="MemberType"
          ></el-table-column>
          <el-table-column
            prop="SignUpNum"
            label="报名人数"
            sortable
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="removePeople(scope.row)"
                type="text"
                size="mini"
                >移除名单</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="infoDialog = false">取 消</el-button>
      </span>
      <div class="pagination-wapper">
        <OfPagination
          :total="totalThree"
          :pageSize="pageSizeThree"
          :currentPage="currentPageThree"
          @onSizeChange="handleSizeChangeThree"
          @onCurrentChange="handleCurrentChangeThree"
        ></OfPagination>
      </div>
    </el-dialog>
    <!--已有班级插入人员dialog-->
    <el-dialog
      title="插入报名人员"
      :visible.sync="inserPeopleDialog"
      width="80%"
      :before-close="handleClose"
      append-to-body
      @selection-change="onSelectionChange"
      :close-on-click-modal="false"
      class="fistdig"
    >
      <div class="el-dialog-div">
        <el-form
          ref="dataForm1"
          :model="dateForm1"
          :disabled="isdisableds1"
          :rules="materialsRules"
        >
          <el-table
            border
            hightlight-current-row
            style="width: 100%"
            :header-cell-class-name="headerRow"
            :data="noClassPeople"
            ref="multipleTable"
            @selection-change="onSelectionChange"
            :max-height="tableMaxHeight()"
            v-loading="isloading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="Name"
              label="报名人员"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              label="联系电话"
              sortable
            ></el-table-column>
            <el-table-column
              prop="MemberType"
              label="报名人员类型"
              sortable
              align="right"
              :formatter="MemberType"
            ></el-table-column>
            <el-table-column
              prop="SignUpNum"
              label="报名人数"
              sortable
            ></el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="inserPeopleDialog = false">取 消</el-button>
        <el-button type="primary" @click="inserUpdatePeople">提 交</el-button>
      </span>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
    </el-dialog>

    <!--选择调班-->
    <el-dialog
      :title="transferClasstitle"
      :visible.sync="transferClassdialog"
      width="30%"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="el-dialog-div">
        <el-form ref="dataForm3" :model="dataForm3" :disabled="isdisableds3">
          <el-form-item label="培训活动：">
            <el-select v-model="dataForm3.TrainId" placeholder="请选择">
              <el-option
                v-for="item in libraryList"
                :key="item.Id"
                :label="item.Title"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="transferClassdialog = false">取 消</el-button>
        <el-button type="primary" @click="addtransferClassdialog()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      MinimumPeople: 0, // 最低开办人数
      defaultClassId: "", // 默认选中班级id
      inserPeopleDialog: false,
      infoDialog: false, // 详情dailog
      classDialog: false, // 班级dialog
      headerRow: "header-row",
      batchId: "",
      isloading: false,
      dataForm1: {},
      dataForm2: {},
      dataForm3: {},
      isdisableds1: false,
      isdisableds2: false,
      isdisableds3: false,
      personalModel: [],
      materialsRules: {
        ClassName: {
          required: true,
          message: "请输入班级名称",
          trigger: "blur",
        },
      },
      dateForm1: {},
      listData: [],
      libraryList: [],
      formVisible_lifeGuard: false,
      formVisible_groupLecture: false,
      formVisible_personalLecture: false,
      formVisible_library: false,
      formVisible_library_detail: false,
      formVisible_class_detail: false,
      formTitle: "",
      formData: {},
      noClassPeople: [], // 未分配班级人员列表
      isDisabled: false,
      total: 0,
      currentPage: 1,
      pageSize: 15,
      totalTwo: 0,
      currentPageTwo: 1,
      pageSizeTwo: 15,
      totalThree: 0,
      currentPageThree: 1,
      pageSizeThree: 15,
      typeOption: [],
      placeholder: "请输入培训主题",
      activeName: "lifeGuard",
      type: 1,
      applyType: 1,
      lectureType: 0,
      lifeGuardModel: [],
      groupLectureModel: [],
      personalLectureModel: [],
      libraryModel: [],
      SaveClassData: {}, // 新增参数
      classPeople: [], // 班级人员列表
      classModel: [],
      TrainIdstr: "",
      transferClasstitle: "",
      transferClassdialog: false,
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.MinimumPeople = this.$route.query.Id;
    this.loadData();
  },
  methods: {
    // 获取班级列表
    loadData() {
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        TrainId: this.$route.query.Id,
      };
      api.QueryTrainClassByClass(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.classModel = rep.data.Data.rows;
        }
      });
    },
    handleTabsClick() {},
    // 班级人员列表
    showInfo(item) {
      this.defaultClassId = item.Id;
      this.infoDialog = true;
      this.getClassPeople(item.Id);
    },
    //确认开办
    openClass(rowData) {
      var tips = "请确认是否开班？";
      if (rowData.StuNum < this.MinimumPeople) {
        tips = "班级人数未达到最低开班人数，请确认是否开班？";
      }
      this.$confirm(tips, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api
          .UpdateTrainClassIsClassed(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.loadData();
              this.isloading = false;
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.isConfirm = false;
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
      this.formData = rowData;
      this.formVisible = true;
    },
    //调班
    innerTransfer(rowData) {
      this.TrainIdstr = rowData.TrainId;
      this.dataForm3.Id = rowData.Id;
      this.transferClasstitle = "调班";
      this.transferClassdialog = true;
      this.getLibraryOption();
    },
    //获取调班培训活动
    getLibraryOption() {
      let params = { Id: this.TrainIdstr };
      api.QuerylifeGuard(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.libraryList = rep.data.Data;
        }
      });
    },
    //自动分班
    autoCreate() {
      let vm = this;
      this.$confirm("是否自动分班", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: vm.$route.query.Id };
        api
          .SaveTrainClassByAutoClass(params)
          .then((res) => {
            if (res.data.Code === 0) {
              vm.$message({
                message: "分班成功",
                type: "success",
              });
              vm.loadData();
            } else {
              vm.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {});
      });
    },
    //调班
    addtransferClassdialog() {
      api
        .TransfertoClass(this.dataForm3)
        .then((rep) => {
          this.isConfirm = false;
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.transferClassdialog = false;
            this.loadData();
            this.CallBackdata = this.dataForm3;
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.isConfirm = false;
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    getClassPeople(item) {
      // 获取班级人员列表
      let vm = this;
      let params = {
        PageIndex: vm.currentPageThree,
        PageSize: vm.pageSizeThree,
        TrainId: vm.$route.query.Id,
        ClassId: item,
      };
      api.QueryTrainApplyByClassId(params).then((rep) => {
        if (rep.data.Code === 0) {
          vm.totalThree = rep.data.Data.total;
          vm.classPeople = rep.data.Data.rows;
        }
      });
    },
    // 已有班级插入新成员
    inserUpdatePeople() {
      let vm = this;
      const request = {
        ApplyId: vm.batchId,
        Id: vm.defaultClassId,
      };
      api.SaveTrainClassStu(request).then((rep) => {
        if (rep.data.Code === 0) {
          vm.inserPeopleDialog = false;
          vm.$message({
            message: "提交成功",
            type: "success",
          });
          this.getClassPeople(vm.defaultClassId);
          this.loadData();
        }
      });
    },
    // 新增人员 dialog
    showInserDialog() {
      this.inserPeopleDialog = true;
      this.loadDatabyclassId();
    },
    // 选中人员名单
    onSelectionChange(rowItems) {
      if (rowItems.length) {
        const ids = [];
        const totalNum = 0;
        for (var i = 0; i < rowItems.length; i++) {
          ids.push(rowItems[i].Id);
        }
        this.batchId = ids.join(",");
        this.Totalnum = rowItems.length;
      }
    },
    // 新增班级提交人员名单
    addmaterialsdialog() {
      if (this.batchId === "") {
        return this.$message({
          message: "报名人员不能为空",
          type: "error",
        });
      }
      this.SaveClassData.Id = this.batchId;
      this.SaveClassData.ClassType = 1;
      this.SaveClassData.StuNum = this.Totalnum;
      this.SaveClassData.TrainId = this.$route.query.Id;
      let params = Object.assign({}, this.SaveClassData);
      api
        .SaveTrainClass(params)
        .then((rep) => {
          this.isConfirm = false;
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.loadData();
            this.classDialog = false;
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.isConfirm = false;
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //移除人员
    removePeople(item) {
      this.$confirm("是否此名单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = { Id: item.Id };
          api
            .DeleteTrainClassStu(params)
            .then((res) => {
              if (res.data.Code === 0) {
                this.getClassPeople(item.ClassId);
                this.loadData();
                this.$message({
                  message: "移除成功",
                  type: "success",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    // 查询未分班人数
    loadDatabyclassId() {
      let vm = this;
      let params = {
        PageIndex: vm.currentPageTwo,
        PageSize: vm.pageSizeTwo,
        TrainId: vm.$route.query.Id,
        ClassId: "",
      };
      api.QueryTrainApplyByClassId(params).then((rep) => {
        if (rep.data.Code === 0) {
          vm.totalTwo = rep.data.Data.total;
          vm.noClassPeople = rep.data.Data.rows;
        }
      });
    },
    handleClose(done) {
      done();
    },
    //新增分班
    createDialog() {
      let vm = this;
      vm.classDialog = true;
      vm.loadDatabyclassId();
    },
    ClassType(rowData) {
      return rowData.ClassType == 0 ? "独立班" : "非独立班";
    },
    IsReachSize(rowData) {
      return rowData.IsReachSize == 0 ? "否" : "是";
    },
    IsClassed(rowData) {
      return rowData.IsClassed == 0 ? "否" : "是";
    },
    MemberType(rowData) {
      return rowData.MemberType == 1 ? "个人" : "团体";
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //改变分页大小
    handleSizeChangeTwo(val) {
      this.currentPageTwo = 1;
      this.pageSizeTwo = val;
      this.loadDatabyclassId();
    },
    //改变当前页码
    handleCurrentChangeTwo(val) {
      if (this.totalTwo > this.pageSizeTwo) {
        this.currentPageTwo = val;
        this.loadDatabyclassId();
      }
    },
    //改变分页大小
    handleSizeChangeThree(val) {
      this.currentPageThree = 1;
      this.pageSizeThree = val;
      this.getClassPeople(this.defaultClassId);
    },
    //改变当前页码
    handleCurrentChangeThree(val) {
      if (this.totalThree > this.pageSizeThree) {
        this.currentPageThree = val;
        this.getClassPeople(this.defaultClassId);
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
  components: {
    BasePage,
    OfPagination,
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  /* border-right: solid 1px #efefef; */
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
/* .el-date-editor >>> .el-input__inner {
  padding-left: 10px !important;
} */

.el-select >>> .el-input__inner {
  width: 3rem;
}

/* .el-date-editor >>> .el-input__inner {
  width: 60%;
} */
.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
